import React from 'react';
import { Helmet } from 'react-helmet-async';
import html2pdf from 'html2pdf.js';
import $ from 'jquery';
import { PrinterIcon } from '@heroicons/react/24/solid';
import { sendGAPageview } from '@/utils/gaConsent';
import AidaDisclaimerContentFromMarkdown from './AidaDisclaimerContentFromMarkdown';

export default function AidaDisclaimer() {
  $('.popover').hide();
  sendGAPageview({
    hitType: 'pageview',
    page: '/AIDA-disclaimer',
    title: 'AIDA Disclaimer',
  });

  const downloadSummary = () => {
    const element = document.getElementById('printer');
    if (!element) return;
    element.classList.add('pdf-mode');
    const opt = {
      margin: [20, 40, 40, 20] as [number, number, number, number],
      filename: 'aida-disclaimer.pdf',
      image: { type: 'jpeg' as const, quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'portrait' as const },
      pagebreak: {
        mode: ['avoid-all', 'css', 'legacy'],
      },
    };
    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        element.classList.remove('pdf-mode');
      });
  };

  return (
    <React.Fragment>
      <Helmet>
        <title>DISGENET: AIDA Disclaimer</title>
        <meta name="description" content="The DISGENET AI assistant, AIDA for DISGENET platform." />

        {/* Open Graph Tags for LinkedIn */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.disgenet.com/AIDA-disclaimer" />
        <meta property="og:title" content="DISGENET: Aida Disclaimer" />
        <meta property="og:description" content="It combines the power of generative AI with the capabilities of the DISGENET REST API." />
      </Helmet>

      <section>
        <link rel="canonical" href="/aida-disclaimer" />
        <div className="container txt-contenido text-right">
          <button
            className="btn bg-light rounded-circle mr-12"
            onClick={downloadSummary}
            title="Download PDF"
          >
            <PrinterIcon className="w-4 h-4" />
          </button>
        </div>
        <div className="container txt-contenido" id="printer">
          <AidaDisclaimerContentFromMarkdown />
        </div>
      </section>
    </React.Fragment>
  );
}
